import React from 'react';

import { PriceChangeRequestBatch } from '../../../codegen/graphql';
import { CompetitorDetailsHoverCard } from './CompetitorDetailsHoverCard';

export type BatchCardCompetitorBlockProps = {
    competitor: PriceChangeRequestBatch['competitor'];
    statPill: React.ReactNode;
};

export function BatchCardCompetitorBlock({
    competitor,
    statPill,
}: BatchCardCompetitorBlockProps) {
    if (competitor == null) {
        return statPill;
    }
    return (
        <CompetitorDetailsHoverCard competitor={competitor}>
            {statPill}
        </CompetitorDetailsHoverCard>
    );
}
